// Display helpers for Regieberichte: euros from cents, hours from minutes, dates.

const localeOf = lng => ({ de: "de-DE", en: "en-GB", tr: "tr-TR", ar: "ar" })[lng] || "de-DE";

export const formatEuro = (cents, lng) =>
  new Intl.NumberFormat(localeOf(lng), { style: "currency", currency: "EUR" }).format(
    Number(cents || 0) / 100
  );

/** 495 → "8:15" */
export const formatMinutes = minutes => {
  const m = Math.max(0, Math.round(Number(minutes || 0)));
  return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`;
};

export const formatQuantity = (value, lng) =>
  new Intl.NumberFormat(localeOf(lng), { maximumFractionDigits: 3 }).format(Number(value || 0));

/** "2026-10-01" → "01.10.2026" */
export const formatDay = iso => {
  const [y, m, d] = String(iso || "").split("-");
  return d ? `${d}.${m}.${y}` : "";
};

export const formatDateTime = (value, lng) =>
  value
    ? new Date(value).toLocaleString(localeOf(lng), { dateStyle: "medium", timeStyle: "short" })
    : "";

/** Euro amount typed by a person ("52,50", "52.5") → cents; empty → 0. */
export const euroToCents = value => {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(String(value).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
};

export const centsToEuro = cents => Math.round(Number(cents || 0)) / 100;

export const STATUS_COLORS = {
  draft: "default",
  signed: "success",
  refused: "warning",
  invoiced: "processing"
};

export const statusLabels = t => ({
  draft: t("Draft"),
  signed: t("Signed"),
  refused: t("Signature refused"),
  invoiced: t("Invoiced")
});

/**
 * Props for an InputNumber holding money or a quantity: shows the language's decimal separator
 * and accepts both "52,50" and "52.50" whatever the UI language ("1.234,50" works as well).
 */
export const decimalInputProps = lng => ({
  decimalSeparator: lng === "en" ? "." : ",",
  parser: value => {
    const text = String(value ?? "").replace(/[\s€]/g, "");
    return text.includes(",") ? text.replace(/\./g, "").replace(",", ".") : text;
  }
});
